import React, { useRef,useEffect } from 'react'
import './index.scss'
// import {showToast} from '@/components/toast'
import html2canvas from 'html2canvas';
import {connect} from 'react-redux'
// 车队信息
import { fleetinfoAction } from '@/store/actions/fleetinfoAction'
const mapStateToProps = (state) => ({
    //邀请链接
    fleetQrCodeUrl : state.getIn(['fleetinfoReducer', 'fleetQrCodeUrl']),
})
const mapDispatchToProps = (dispatch) => ({
    //车队信息总览
    handleGetFleetInfo(){
        return dispatch(fleetinfoAction());
    }

})
const FleetQRcode = ({handleGetFleetInfo,fleetQrCodeUrl}) => {
    // 
    useEffect(() => {
        // 车队信息拿到邀请链接
        handleGetFleetInfo();
        return () => {
        }
    }, [handleGetFleetInfo])
    // 获取截图二维码
    let qcCode = useRef();
    const handleOnSavePhone = () => {
        //截图
        html2canvas(qcCode.current, {
            allowTaint: false,
            useCORS: true,
            scale: 2,
            // imageTimeout : 10000,
            dpi: window.devicePixelRatio * 2
        }).then(function (canvas) {
            let d = canvas.toDataURL('image/png');
            //截取只保留base64 字符串
            let packD = d.substring(d.indexOf(',') + 1);
            // 截图成功
            var u = navigator.userAgent;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            let params = {
                title: 'img',
                url: packD
            }
            if (isAndroid) {
                window.savePicture.onSavePicture(packD);
            } else if (isIOS) {
                window.WebViewJavascriptBridge.callHandler('handleSavePhone', params);
            }
            // 保存成功
            // showToast('图片保存成功')
        })
    }
    return (
        <div className="fleet-qr-code__box">
            <div className="fleet-qr-code__tit">
                扫描下方二维码即可加入车队群
            </div>
            <div className='qrcode-box' ref={qcCode}>
                {/* <QRCode
                    value={fleetQrCodeUrl}  //value参数为生成二维码的链接
                    fgColor="#3ea30f"  //二维码的颜色
                /> */}
                <img src={ fleetQrCodeUrl } alt="" />
            </div>
            <footer>
                <button onClick={handleOnSavePhone} style={(React.colorConfig ? React.colorConfig.buttonBg : {})}>保存二维码图片</button>
            </footer>
        </div>
    )
}
export default connect(mapStateToProps,mapDispatchToProps)(FleetQRcode)